import { createContext, useContext, useEffect, useState } from "react";

const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  const [id, setId] = useState("");
  const [customParams, setCustomParams] = useState({});
  const [resultsLayoutMode, setResultsLayoutMode] = useState("grid");

  const {
    anchors_key,
    search_key,
    show_search_input,
    use_voice,
    debounce_time,
    search_page_path,
    input_placeholder,
    inputWidth,
    inputHeight,
    inputBorderConfig,
    inputBorderRadius,
    inputFontSize,
    inputFontColor,
    inputBgColor,
    inputIconSize,
    inputIconColor,
    inputResponsive,
    show_search_anchors_input,
    sortOptions,
    page_title_tpl_term,
    page_title_tpl_anchor,
    page_title_tpl_term_anchored,
    requestCustomParams,
  } = window.bn_config_search_page;

  useEffect(() => {
    setCustomParams(requestCustomParams || {});
  }, [requestCustomParams]);

  useEffect(() => {
    document.addEventListener("beon.search.setup.customparams", (event) => {
      event.preventDefault();
      const details = event.detail || event.details || {};
      if (details.data) {
        setCustomParams(details.data);

        if (details.callback && typeof details.callback === "function") {
          details.callback();
        }
      }
    });
  }, []);

  return (
    <ConfigContext.Provider
      value={{
        tenant_id: id,
        api_key: id,
        anchors_key,
        search_key,
        show_search_input,
        use_voice,
        debounce_time,
        search_page_path,
        input_placeholder,
        inputWidth,
        inputHeight,
        inputBorderConfig,
        inputBorderRadius,
        inputFontSize,
        inputFontColor,
        inputBgColor,
        inputIconSize,
        inputIconColor,
        inputResponsive,
        setId,
        show_search_anchors_input,
        sortOptions,
        page_title_tpl_term,
        page_title_tpl_anchor,
        page_title_tpl_term_anchored,
        customParams,
        resultsLayoutMode,
        setResultsLayoutMode,
      }}
    >
      {children}
    </ConfigContext.Provider>
  );
};

export const useConfig = () => {
  const {
    tenant_id,
    api_key,
    anchors_key,
    search_key,
    show_search_input,
    use_voice,
    debounce_time,
    search_page_path,
    setId,
    input_placeholder,
    inputWidth,
    inputHeight,
    inputBorderConfig,
    inputBorderRadius,
    inputFontSize,
    inputFontColor,
    inputBgColor,
    inputIconSize,
    inputIconColor,
    inputResponsive,
    show_search_anchors_input,
    sortOptions,
    page_title_tpl_term,
    page_title_tpl_anchor,
    page_title_tpl_term_anchored,
    customParams,
    resultsLayoutMode,
    setResultsLayoutMode,
  } = useContext(ConfigContext);

  return {
    tenant_id,
    api_key,
    anchors_key,
    search_key,
    show_search_input,
    use_voice,
    debounce_time,
    search_page_path,
    setId,
    input_placeholder,
    inputWidth,
    inputHeight,
    inputBorderConfig,
    inputBorderRadius,
    inputFontSize,
    inputFontColor,
    inputBgColor,
    inputIconSize,
    inputIconColor,
    inputResponsive,
    show_search_anchors_input,
    sortOptions,
    page_title_tpl_term,
    page_title_tpl_anchor,
    page_title_tpl_term_anchored,
    customParams,
    resultsLayoutMode,
    setResultsLayoutMode,
  };
};
